export const GET_DAILY_CHALLENGES = 'dailyChallenges/GET_DAILY_CHALLENGES';
export const GET_SCHOOL_DAILY_CHALLENGES =
  'dailyChallenges/GET_SCHOOL_DAILY_CHALLENGES';
export const UPDATE_DAILY_CHALLENGE_LIST_ITEM =
  'dailyChallenges/UPDATE_DAILY_CHALLENGE_LIST_ITEM';
export const REMOVE_DAILY_CHALLENGE_BY_ID =
  'dailyChallenges/REMOVE_DAILY_CHALLENGE_BY_ID';
